var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"custom-error"},[_c('i',{staticClass:"vcore_icon icon-warning"}),_vm._v("\n    "+_vm._s(_vm.error)+"\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }